var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hmi-piloto"},[_c('div',{staticClass:"outer-circle"},[_c('div',{staticClass:"inner-circle",style:(_vm.innerStyle)})]),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }